import React from 'react';
import { X } from 'lucide-react';
import Modal from 'react-bootstrap/Modal';
import styles from "../../_css/NotificationManagement.module.css";

const ViewNotificationModal = ({ show, onHide, notification }) => {
    if (!notification) return null;

    // Function to get urgency badge style
    const getUrgencyStyle = (urgency) => {
        switch (urgency) {
            case "High":
                return { backgroundColor: "#FEF2F2", color: "#DC2626", borderColor: "#FECACA" };
            case "Medium":
                return { backgroundColor: "#FFFBEB", color: "#D97706", borderColor: "#FED7AA" };
            case "Low":
                return { backgroundColor: "#F0FDF4", color: "#16A34A", borderColor: "#A7F3D0" };
            default:
                return { backgroundColor: "#F3F4F6", color: "#6B7280", borderColor: "#D1D5DB" };
        }
    };

    // Function to get delivery methods as string
    const getDeliveryMethodsString = (deliveryMethod) => {
        if (!deliveryMethod) return "-";
        const methods = [];
        if (deliveryMethod?.includes("popup")) methods.push("Popup");
        if (deliveryMethod?.includes("banner")) methods.push("Banner");
        if (deliveryMethod?.includes("email")) methods.push("Email");
        return methods.length > 0 ? methods.join(", ") : "-";
    };

    // Function to get status style
    const getStatusStyle = (status) => {
        switch (status) {
            case "Sent":
                return { backgroundColor: "#F0FDF4", color: "#16A34A", borderColor: "#A7F3D0" };
            case "Scheduled":
                return { backgroundColor: "#EFF6FF", color: "#2563EB", borderColor: "#BFDBFE" };
            case "Draft":
                return { backgroundColor: "#FFFBEB", color: "#D97706", borderColor: "#FED7AA" };
            default:
                return { backgroundColor: "#F3F4F6", color: "#6B7280", borderColor: "#D1D5DB" };
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            dialogClassName={styles.modal38}
        >
            {/* Header */}
            <Modal.Header className={styles.modalHeader}>
                <Modal.Title className={styles.modalTitle}>
                    Notification Details
                </Modal.Title>
                <button
                    onClick={onHide}
                    className={styles.closeButton}
                >
                    <X size={24} color="#374151" />
                </button>
            </Modal.Header>

            {/* Body */}
            <Modal.Body className={styles.modalBody}>
                {/* Title */}
                <div className={styles.detailField}>
                    <label className={styles.detailLabel}>Title</label>
                    <div className={styles.detailValue}>
                        {notification.title || "N/A"}
                    </div>
                </div>

                {/* Message */}
                <div className={styles.detailField}>
                    <label className={styles.detailLabel}>Message</label>
                    <div className={styles.detailMessage}>
                        {notification.message || notification.description || "No message provided"}
                    </div>
                </div>

                {/* Category and Audience */}
                <div className={styles.detailRow}>
                    <div className={styles.detailField}>
                        <label className={styles.detailLabel}>Category</label>
                        <div className={styles.detailValue}>
                            {notification.category || "N/A"}
                        </div>
                    </div>
                    <div className={styles.detailField}>
                        <label className={styles.detailLabel}>Audience</label>
                        <div className={styles.detailValue}>
                            {notification.audienceType || notification.Audience || "N/A"}
                        </div>
                    </div>
                </div>

                {/* Urgency and Status */}
                <div className={styles.detailRow}>
                    <div className={styles.detailField}>
                        <label className={styles.detailLabel}>Urgency</label>
                        <span
                            className={styles.detailBadge}
                            style={getUrgencyStyle(notification.urgency)}
                        >
                            {notification.urgency || "Medium"}
                        </span>
                    </div>
                    <div className={styles.detailField}>
                        <label className={styles.detailLabel}>Status</label>
                        <span
                            className={styles.detailBadge}
                            style={getStatusStyle(notification.status)}
                        >
                            {notification.status || "N/A"}
                        </span>
                    </div>
                </div>

                {/* Delivery Methods */}
                <div className={styles.detailField}>
                    <label className={styles.detailLabel}>Delivery Methods</label>
                    <div className={styles.detailValue}>
                        {getDeliveryMethodsString(notification.deliveryMethod)}
                    </div>
                </div>

                {/* Signature */}
                <div className={styles.detailField}>
                    <label className={styles.detailLabel}>Signature</label>
                    <div className={styles.detailValue}>
                        {notification.signature || "N/A"}
                    </div>
                </div>

                {/* Created Date */}
                {notification.createdDate && (
                    <div className={styles.detailField}>
                        <label className={styles.detailLabel}>Created Date</label>
                        <div className={styles.detailValue}>
                            {notification.createdDate}
                        </div>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ViewNotificationModal;